import {Injectable} from '@angular/core';
import {HttpService} from '../http/http.service';
import {catchError, map, Observable} from 'rxjs';
import {iResponse, iResponseList} from '../../models/response/response.model';
import {PharmacyModel} from '../../models/pharmacy/pharmacy.model';

@Injectable({
    providedIn: 'root'
})
export class PharmacyService extends HttpService {

    getPharmacies(): Observable<iResponseList<PharmacyModel>> {
        return this.get(`pharmacies`).pipe(
            map((response: iResponseList<PharmacyModel>) => {
                return response;
            }),
            catchError(error => {
                throw error
            })
        )
    }

    createPharmacy(pharmacy: PharmacyModel): Observable<iResponse<PharmacyModel>> {
        return this.post(`pharmacies`, pharmacy).pipe(
            map((response: iResponse<PharmacyModel>) => {
                return response;
            }),
            catchError(error => {
                throw error
            })
        )
    }

    updatePharmacy(pharmacy: PharmacyModel): Observable<iResponse<PharmacyModel>> {
        return this.put(`pharmacies/${pharmacy.id}`, pharmacy).pipe(
            map((response: iResponse<PharmacyModel>) => {
                return response;
            }),
            catchError(error => {
                throw error
            })
        )
    }

    deletePharmacy(id: string): Observable<iResponse<boolean>> {
        return this.delete(`pharmacies/${id}`).pipe(
            map((response: iResponse<boolean>) => {
                return response;
            }),
            catchError(error => {
                throw error
            })
        )
    }

    addRegularPharmacy(pharmacy: PharmacyModel): Observable<iResponse<PharmacyModel>> {
        const pharmacyData = {
            regularPharmacy: pharmacy,
        }
        return this.patch(`patients/${pharmacy.userId}/pharmacy`, pharmacyData).pipe(
            map((response: iResponse<PharmacyModel>) => {
                return response;
            }),
            catchError(error => {
                throw error
            })
        )
    }


}
